import endsWith from 'lodash-es/endsWith';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux/actions';
import Route from 'react-router-dom/Route';
import { PAGE_CUSTOMER } from '../App';
import { Button } from '../components/actions';
import chartIcon from '../img/chart.svg';
import clockIcon from '../img/clock.svg';
import crossIcon from '../img/cross-icon.svg';
import { getUser, selectIsUserAuthorized } from '../selectors';
import s from './Base.css';
import Footer from './Footer';
import Header from './Header';

const mapStateToProps = (state, ownProps) => ({
    isUserLoggedIn: selectIsUserAuthorized(state),
    userData: getUser(state),
});

class BaseLayout extends React.Component {
    render() {
        const { component: Component, isUserLoggedIn, userData, dispatch, ...rest } = this.props;

        return (
            <Route
                {...rest}
                render={matchProps => {
                    const isOnReportsPage = endsWith(matchProps.location.pathname, PAGE_CUSTOMER.Reports);
                    const isOnRequestReportPage = endsWith(matchProps.location.pathname, PAGE_CUSTOMER.RequestReport);
                    const isOnReportsListPage = endsWith(matchProps.location.pathname, PAGE_CUSTOMER.ReportsList);
                    const locationContainsReports =
                        isOnReportsPage || isOnRequestReportPage || isOnReportsListPage ? true : false;

                    return (
                        <div>
                            <Header>
                                {isUserLoggedIn && userData && locationContainsReports && (
                                    <div className={s.sectionInner}>
                                        {(!isOnReportsListPage && (
                                            <Button
                                                onClick={this.handleGoToReportsListPage}
                                                label={isOnRequestReportPage ? 'Cancel' : 'Request new report'}
                                                withBox={true}
                                                boxIcon={isOnRequestReportPage ? crossIcon : chartIcon}
                                                boxOnLeft={true}
                                                align="left"
                                            />
                                        )) ||
                                            (!isOnReportsPage && (
                                                <Button
                                                    onClick={this.handleGoToReportsHistoryPage}
                                                    label="Reports history"
                                                    withBox={true}
                                                    boxIcon={clockIcon}
                                                    boxOnLeft={true}
                                                    align="left"
                                                />
                                            ))}
                                    </div>
                                )}
                            </Header>

                            <div>
                                <Component {...matchProps} />
                            </div>

                            <Footer />
                        </div>
                    );
                }}
            />
        );
    }

    handleGoToReportsListPage = e => {
        this.props.dispatch(push(PAGE_CUSTOMER.ReportsList));
    };

    handleGoToReportsHistoryPage = e => {
        this.props.dispatch(push(PAGE_CUSTOMER.Reports));
    };
}

export default connect(mapStateToProps)(BaseLayout);



// WEBPACK FOOTER //
// ./app/web/src/layout/Base.jsx